import type { TemplateField } from '@branditdev/mf-types'
import { connect } from 'react-redux'
import ProductTemplateField from './ProductTemplateField'
import { areTemplateFieldDependenciesMet, type TemplateFieldValuesState } from './templateFields/templateFieldValues'

type ProductTemplateFieldsProps = {
  bundleProduct?: { bundle_group_product_id: string | number }
  isBundle?: boolean
  templateFields?: TemplateField[] | null
  templateFieldsSelection: TemplateFieldValuesState
}

type ProductTemplateFieldsState = {
  productPage: {
    templateFields: TemplateFieldValuesState
  }
}

const ProductTemplateFields = (props: ProductTemplateFieldsProps) => {
  const { isBundle, bundleProduct, templateFields, templateFieldsSelection } = props
  const hasSortOrder = (field: TemplateField) => field.sort_order !== null && field.sort_order !== undefined

  const dependencyRequirementsMet = (field: TemplateField) => {
    return areTemplateFieldDependenciesMet({
      field,
      templateFieldValues: templateFieldsSelection,
      isBundle,
      bundleProduct
    })
  }
  return (
    <>
      {[...(templateFields ?? [])]
        .sort(
          (a, b) =>
            Number(hasSortOrder(b)) - Number(hasSortOrder(a)) || Number(a.sort_order ?? 0) - Number(b.sort_order ?? 0)
        )
        .map((field, index) => {
          return (
            <div key={index} className="description-container">
              <div className="mf-mb-10">
                <ProductTemplateField
                  field={field}
                  dependencyRequirementsMet={dependencyRequirementsMet}
                  isBundle={isBundle === true}
                  bundleProduct={bundleProduct}
                />
              </div>
            </div>
          )
        })}
    </>
  )
}

const mapStateToProps = (state: ProductTemplateFieldsState) => ({
  templateFieldsSelection: state.productPage.templateFields
})

export default connect(mapStateToProps)(ProductTemplateFields)
